'use strict';
module.exports = function(app) {
    function get_time() {
        return (new Date()).getTime();
    }
    app.factory('socket', function ($rootScope) {
        var socket = io.connect();
        
        var last_updated_time, time_offset, round_trip;
        socket.on('pong', function(sent_time, received_time, reply_time) {
            var received_reply_time = get_time();
            time_offset = ((received_time - sent_time) + (reply_time - received_reply_time)) / 2;
            round_trip = (received_reply_time - sent_time) - (received_time-reply_time);
            last_updated_time = received_reply_time;
        });
        socket.emit('pong', get_time());
        
        /** Update the delay every 60 seconds */
        /*
        setTimeout(function() {
            socket.emit('pong', get_time());
        }, 60*1000);
        */
        
        return {
            $getTime: function() {
                var now = new Date();
                now.setTime( get_time() + time_offset );
                return now;
            },
            on: function (eventName, callback) {
                socket.on(eventName, function () {
                    var args = arguments;
                    $rootScope.$apply(function () {
                        callback.apply(socket, args);
                    });
                });
            },
            once: function (eventName, callback) {
                socket.once(eventName, function () {
                    var args = arguments;
                    $rootScope.$apply(function () {
                        callback.apply(socket, args);
                    });
                });
            },
            emit: function (eventName, arg1, arg2, arg3) {
                var frontend_emit = get_time();
                var timing = {
                    'event': eventName,
                    'frontend_start': undefined, /** TODO: How to get this information? Should be when the button has been pressed, etc. */
                    'frontend_emit': frontend_emit
                };
                var callback;
                function callback() {
                    var args = arguments;
                    $rootScope.$apply(function () {
                        if (callback) {
                            callback.apply(socket, args);
                        }
                    });
                }

                socket.once('success:'+eventName, function(a, b, c) {
                    var frontend_received = get_time();
                    var t = (c && (typeof c === 'object')) ? c : ((b && (typeof b === 'object')) ? b : a);
                    t.frontend_received = frontend_received;
                    t.frontend_end = undefined; /* TODO: How to get this information? Should be when angular view is finished. */
                    socket.emit('log:timing', t);
                });

                var len = arguments.length;

                if( (len === 2) && (typeof arg1 === 'function') ) {
                    callback = arg1;
                    len -= 1;
                } else if( (len === 3) && (typeof arg1 === 'function') ) {
                    callback = arg2;
                    len -= 1;
                } else if( (len === 4) && (typeof arg1 === 'function') ) {
                    callback = arg3;
                    len -= 1;
                }

                if(len === 1) {
                    return socket.emit(eventName, timing, callback);
                }
                if(len === 2) {
                    return socket.emit(eventName, arg1, timing, callback);
                }
                if(len === 3) {
                    return socket.emit(eventName, arg1, arg2, timing, callback);
                }
                if(len === 4) {
                    return socket.emit(eventName, arg1, arg2, arg3, timing, callback);
                }
            },
            removeListener: function (eventName, callback) {
                if (callback && callback.__ng) {
                  arguments[1] = callback.__ng;
                }
                return socket.removeListener.apply(socket, arguments);
            },
            removeAllListeners: function() {
                return socket.removeAllListeners.apply(socket, arguments);
            }
        };
    });
};



/*****************
 ** WEBPACK FOOTER
 ** ./bidding_product/js/service/socket.service.js
 ** module id = 56
 ** module chunks = 0
 **/